import { getTranslations } from "next-intl/server";
import { SchedulesBlock as SchedulesBlockTypes } from "@/payload-types";

const SchedulesBlock: React.FC<SchedulesBlockTypes> = async (props) => {
  const { title, schedules } = props;
  const t = await getTranslations("web_contact");

  if (!schedules || schedules.length === 0) return null;

  return (
    <div className="flex h-full flex-col gap-6 rounded-lg bg-linear-to-b from-[#2A2D3F] via-[#0A0A0E] to-black p-8 text-white shadow-2xl">
      {title && (
        <h2 className="font-bold underline underline-offset-8 decoration-primary">{title}</h2>
      )}
      <ul className="flex flex-col divide-y divide-primary/30">
        {schedules.map(({ id, days, hours }) => (
          <li key={id} className="flex justify-between gap-4 py-3">
            <span className="font-bold">{t(`days.${days}`)}</span>
            <span className="text-white/80">{hours}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export { SchedulesBlock };
